module.exports = __webpack_public_path__ + "static/img/xinpin.e27d948.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/b2c/xinpin.png
// module id = qZKP
// module chunks = 18